const state = {
  show: false,
  showEditor: false,
  currentDocument: {}
}

const mutations = {
  showDocumentsEditor (state, document = null) {
    state.currentDocument = document || {}
    state.showEditor = !!document
  },
  showDocumentsMenu (state, payload) {
    state.show = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
